import Vue from 'vue';
import store from './store';
import router from './router';
import App from './App.vue';

import axios from 'axios';

import VueScrollTo from 'vue-scrollto';

import VueAxios from 'vue-axios';

import SimpleVueValidation from 'simple-vue-validator';

//import VueGtm from 'vue-gtm';

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;

Vue.use(VueScrollTo);

Vue.use(SimpleVueValidation);

/*if(process.env.NODE_ENV === 'production') {
    Vue.use(VueGtm, {
        id: 'GTM-......',
        enabled: true,
        debug: false,
        loadScript: true,
        vueRouter: router,
    });
}*/

/*if(process.env.NODE_ENV === 'production') {
    Vue.use(VueAnalytics, {
        id: 'UA-28793215-1',
        router
    });
}*/

Vue.axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? '/api' : 'https://app.drommenomdetgode.no/api'

new Vue({
    store,
    router,
    render: h => h(App),
    validations: {}
}).$mount('#app')
